import { useQuery } from "react-query";
import {
  getHmgs,
  getHmg,
  getHmgProjectLists,
  getHMGData,
  getRolesMappedToHMG
} from "../api/hmg";

const useGetHmgs = (options = {}) => useQuery("getHmgs", getHmgs, options);

const useGetHmg = (id, options = {}) =>
  useQuery(["getHmg", id], () => getHmg(id), options);

const useGetHmgProjectLists = (id, options = {}) =>
  useQuery(["getHmgProjectLists", id], () => getHmgProjectLists(id), options);

const useGetHMGData = (options) => {
  return useQuery("HMGDataNew", () => getHMGData(), {
    ...options,
  });
};

const useGetRolesMappedToHMG = (id, options = {}) =>
  useQuery(["getHmgProjectLists", id], () => getRolesMappedToHMG(id), options);

export {
  useGetHmgs,
  useGetHmg,
  useGetHmgProjectLists,
  useGetHMGData,
  useGetRolesMappedToHMG,
};
